import { registerTheme } from '../../theme';
import { DEFAULT_COLUMN_THEME } from '../column/theme';
registerTheme('stackedColumn', DEFAULT_COLUMN_THEME);
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/stacked-column/theme.js
// module id = null
// module chunks = 